import { fmtDate } from "@/lib/format";

/** Календарные хелперы выбора интервала дат (`components/DateRangePicker`).
 *
 * Все даты — локальные ISO-строки `yyyy-mm-dd` (сравниваются лексикографически
 * корректно). `Date.toISOString()` сознательно не используется: он в UTC, и
 * ночью по Москве отдаёт вчерашний день. */

export interface DayCell {
  iso: string;
  day: number;
  /** Ячейка принадлежит показываемому месяцу (хвосты соседних — приглушены). */
  inMonth: boolean;
}

export function toISODate(d: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Локальная дата со сдвигом в днях («сегодня», «завтра» для пресетов). */
export function localISODate(offsetDays = 0): string {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return toISODate(d);
}

/** Сетка месяца: недели по 7 дней, с ПОНЕДЕЛЬНИКА (`getDay()`: вс=0). Число
 *  недель переменное (февраль с понедельника — 4, обычный месяц — 5–6). */
export function monthGrid(year: number, month0: number): DayCell[][] {
  const first = new Date(year, month0, 1);
  const d = new Date(year, month0, 1 - ((first.getDay() + 6) % 7));
  const weeks: DayCell[][] = [];
  do {
    const week: DayCell[] = [];
    for (let i = 0; i < 7; i++) {
      week.push({ iso: toISODate(d), day: d.getDate(), inMonth: d.getMonth() === month0 });
      d.setDate(d.getDate() + 1);
    }
    weeks.push(week);
  } while (d.getMonth() === month0);
  return weeks;
}

export function addMonths(
  year: number,
  month0: number,
  delta: number,
): { year: number; month0: number } {
  const t = year * 12 + month0 + delta;
  return { year: Math.floor(t / 12), month0: ((t % 12) + 12) % 12 };
}

const MONTHS = [
  "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
  "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
];

export function monthTitle(year: number, month0: number): string {
  return `${MONTHS[month0]} ${year}`;
}

/** Пара тапов в любом порядке → упорядоченный интервал. */
export function normalizeRange(a: string, b: string): [string, string] {
  return a <= b ? [a, b] : [b, a];
}

/** Подпись на кнопке: «10.08.2026» или «10.08.2026 — 12.08.2026». */
export function fmtRangeLabel(from: string, to: string): string {
  return from === to ? fmtDate(from) : `${fmtDate(from)} — ${fmtDate(to)}`;
}
